<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex sm12>
        <v-layout row wrap>
          <v-flex xs12 md4 pr-4 pb-4 v-for="book in list" :key="book.id">
            <book-card :book="book" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">Cargando...</div>
      <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
      <v-layout slot="no-results">
        <v-flex sm12>
          <v-card height="400px">
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                sm12
                class="text-29-security text-md-center font-weight-bold"
                style="color: #525252"
              >No libros de esta categoría</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import BookCard from "./BookCard";
import config from "@/config";
export default {
  components: {
    BookCard
  },
  props: {
    category: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      list: []
    };
  },
  methods: {
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL + this.url}`;
      axios.get(api, { params: { page: this.page, category: this.category } }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    goToShowBook(id) {
      this.$router.push({
        name: "book-show",
        params: { id: id }
      });
    }
  }
};
</script>
